import { ShiftClaimCancelationActors, WorkApplicationCancelationReasons } from '@types';

export const getWorkApplicationCancelationReason = (
  cancelationReason: WorkApplicationCancelationReasons
) => {
  const workApplicationCancelationReasonsToText = {
    unknown: 'applications.cancelation_states.unknown',
    byFW: 'applications.cancelation_states.by_fw',
    automaticAllSpotsFilled: 'applications.cancelation_states.automatic_all_spots_filled',
    automaticOverlappingShift: 'applications.cancelation_states.automatic_overlapping_shift',
    automaticJobOrShiftDetailsChanged:
      'applications.cancelation_states.automatic_job_or_shift_details_changed',
    archived: 'applications.cancelation_states.archived',
    byOG: 'applications.cancelation_states.by_og',
    byHQ: 'applications.cancelation_states.by_hq',
    byNotWelcomeList: 'applications.cancelation_states.by_not_welcome_list',
  } as const;

  return workApplicationCancelationReasonsToText[cancelationReason];
};

export const getWorkClaimCancelationReason = (cancelationActor: ShiftClaimCancelationActors) => {
  switch (cancelationActor) {
    case 'unknown':
      return 'placements.cancellation_states.unknown';
    case 'byFW':
      return 'placements.cancellation_states.by_fw';
    case 'byOG':
      return 'placements.cancellation_states.by_og';
    case 'byHQ':
      return 'placements.cancellation_states.by_hq';
  }
};
